/** Shared, strict validation for public calculator forms and untrusted handoffs. */
export function inRange(value: unknown, min: number, max: number): value is number {
  return typeof value === "number" && Number.isFinite(value) && value >= min && value <= max;
}

export function hasEvidence(value: unknown): value is string {
  return typeof value === "string" && value.trim().length > 0 && value.length <= 240;
}

/** Empty is unknown, malformed is NaN: neither becomes a fabricated zero. */
export function calculatorNumber(value: string): number | null {
  if (!value.trim()) return null;
  if (!/^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i.test(value.trim())) return NaN;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : NaN;
}

export type CalculatorIssues = { missing: string[]; invalid: string[]; unsupported: string[] };

export function requireNumber(issues: CalculatorIssues, label: string, value: unknown, min: number, max: number): boolean {
  if (value == null) issues.missing.push(label);
  else if (!inRange(value, min, max)) issues.invalid.push(`${label}: enter ${min}–${max}.`);
  else return true;
  return false;
}

export function requireEvidence(issues: CalculatorIssues, label: string, value: unknown): boolean {
  if (value == null || value === "") issues.missing.push(label);
  else if (!hasEvidence(value)) issues.invalid.push(`${label}: use 1–240 characters.`);
  else return true;
  return false;
}
